import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../superadmin/AddDistrict.css';

const AddRegistrationCode = () => {
  const [formData, setFormData] = useState({
    code: '',
    description: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post('/api/registration-codes', formData);
      navigate('/district-admin/registration-codes');
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to create registration code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-district">
      <h2>Add Registration Code</h2>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Code *</label>
          <input
            type="text"
            name="code"
            value={formData.code}
            onChange={handleChange}
            required
            placeholder="e.g., TEST2024"
          />
          <small>This is the code parents will need to enter to register</small>
        </div>

        <div className="form-group">
          <label>Description</label>
          <input
            type="text"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="e.g., Fall 2024 Registration"
          />
          <small>Optional description to help you identify this code</small>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Creating...' : 'Create Code'}
          </button>
          <button 
            type="button" 
            className="btn-secondary" 
            onClick={() => navigate('/district-admin/registration-codes')}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddRegistrationCode;

